<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path d="M12.4303 6.20598L11.0214 6.1543L10.7159 14.4963L12.1249 14.5478L12.4303 6.20598Z" class="icon-fill"/>
      <path d="M9.70495 6.18018H8.29504V14.5222H9.70495V6.18018Z" class="icon-fill"/>
      <path d="M7.28386 14.4961L6.97839 6.15405L5.5694 6.20577L5.8749 14.5478L7.28386 14.4961Z" class="icon-fill"/>
      <path d="M0.610962 2.70239V4.1123H2.08011L3.24561 17.3569C3.27756 17.7209 3.58237 18 3.94775 18H14.0285C14.3939 18 14.6989 17.7207 14.7306 17.3566L15.8961 4.1123H17.389V2.70239H0.610962ZM13.3827 16.5901H4.59329L3.49543 4.1123H14.4808L13.3827 16.5901Z" class="icon-fill"/>
      <path d="M11.3029 0H6.69714C6.04928 0 5.52222 0.527062 5.52222 1.17492V3.40731H6.93212V1.40991H11.0679V3.40731H12.4778V1.17492C12.4778 0.527062 11.9507 0 11.3029 0Z" class="icon-fill"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="18" height="18" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'trash'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>